import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { TimeoutData } from 'src/app/shared/model/timeout-data';
import { TimeoutService } from 'src/app/shared/services/timeout-data.service';
import { errorMapping } from "src/app/shared/constants/errors";
import { cssBrands } from "src/app/shared/constants/cards";
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';
import { DtmService } from 'src/app/services/dtm.service';
import { Dtm, getDtm } from 'src/app/shared/enum/dtm';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { CartService } from 'src/app/shared/services/cart.service';


@Component({
    selector: 'pme-timeout',
    templateUrl: './timeout.component.html',
    styleUrls: ['./timeout.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CheckoutTimeoutComponent implements OnInit {

  @Output() onSuccessButtonClick: EventEmitter<any> = new EventEmitter<any>();

  confirmationData: TimeoutData;

  // Cupons	
  extraBalanceCoupon: any;
  extraBalanceSum: number = 0;
  appliedCoupons: any = [];

  // Valor final
  totalValue: number = 0;

  constructor(
    private timeoutService: TimeoutService,
    private breadcrumb: BreadcrumbService,
    public dtmService: DtmService,
    private sessionStorageService: SessionStorageService,
    private cartService: CartService
  ) {
    breadcrumb.addBreadcrumb("Processamento");
    breadcrumb.disableBreadcrumb();

    this.confirmationData = timeoutService.getTimeoutData();
  }

  ngOnInit(): void {
    let mappedProductName;
    switch (this.confirmationData.product.classificationIdentifier) {
      case "consulta-e-recuperacao-de-dividas":
        mappedProductName = "CS-RDD:Processamento:Timeout";
        break;

      case "monitore-clientes":
        mappedProductName = "Monitoramento:Processamento:Timeout";
        break;

      case "plano-mensal":
        mappedProductName = "Assinatura:Processamento:Timeout";
        break;

      case "saude-do-seu-negocio":
        mappedProductName = "SaudeFinanceira:Processamento:Timeout";
        break;
    }

    let mappedPageName = getDtm(Dtm.ProcessamentoTimeout, this.confirmationData.product.classificationIdentifier);
    this.dtmService.customLoaded([]);
    this.dtmService.pageLoaded(Dtm.ProcessamentoTimeout, this.sessionStorageService.getIsLogged(), mappedPageName);
    this.dtmService.customErrorLoaded(["error"], {
      errorDetail: "",
      errorMessage: errorMapping["timeOutError"],
    });
    this.dtmService.sendPageLoadEvent();

    // Confere cupons
    this.checkForExtraBalanceCoupon();
  }

  getBrandCSSMatching(): string {
    return cssBrands[this.confirmationData.creditCardBrand];
  }

  getPlanType() {
    let planType = this.cartService.getCurrentCart().product.name.split("- ").pop();
    return planType;
  }

  checkForExtraBalanceCoupon() {
    this.appliedCoupons = [];
    this.extraBalanceCoupon = [];
    this.extraBalanceSum = 0;

    if (this.confirmationData && this.confirmationData.discounts) {
      this.confirmationData.discounts.forEach(discount => {
        if (discount.type === "EXTRA_BALANCE") {
          this.extraBalanceCoupon.push(discount);
        } else {
          this.appliedCoupons.push(discount);
          this.totalValue += discount.discountAmount;
        }
      });
    }

    this.totalValue = this.cartService.getCurrentCart().product.value - this.totalValue < 0 ? 0 : this.cartService.getCurrentCart().product.value - this.totalValue;

    if (this.extraBalanceCoupon.length > 0) {
      this.extraBalanceSum = this.extraBalanceCoupon.reduce((accumulator, discount) => {
        return accumulator + discount.extraBalance;
      }, 0);
    }

  }

}
